import { seriesDateLabel, seriesDateStateLabel } from "./courtSeriesModel";
import "./CourtSeries.css";

/*
 * One row per date of a turno fijo with its state in Spanish. Used for the
 * preview (every date, available or not) and for the skipped list of a 409
 * (only unavailable dates), which have the same { date, available?, reason? }
 * shape.
 */
export default function CourtSeriesDateList({
	dates,
	label = "Fechas del turno fijo",
}) {
	return (
		<ul className="csr-dates" aria-label={label}>
			{dates.map((entry) => (
				<li
					key={entry.date}
					className={`csr-date${entry.available ? " is-available" : ""}`}
				>
					<span className="csr-date__day">{seriesDateLabel(entry.date)}</span>
					<span className="csr-date__state">{seriesDateStateLabel(entry)}</span>
				</li>
			))}
		</ul>
	);
}
